import React, { Component } from 'react';
import { connect } from 'react-redux';
//import Dialog from 'material-ui/Dialog';
import Dialog from '@material-ui/core/Dialog';
//import FlatButton from 'material-ui/FlatButton';
import Button from '@material-ui/core/Button';
//import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { isDirty } from 'redux-form';
import {
  createCase,
  casePartSelect,
  showConfirmModal,
  createCasePreFilledDataByPatientIdentifier,
} from '../../redux/actions';
import { MODAL_CONFIRM_DISCARD_CHANGES, CASE_PART_ONE, userRoles } from '../../constants/constants';
import CreateNewCaseButton from '../case/CreateNewCaseButton';

class CreateNewCase extends Component {

  options = {
    CREATE_EMPTY: 'create-empty',
    RETRIEVE_INFO: 'retrieve-info',
  }

  state = {
    open: false,
    optionSelected: this.options.CREATE_EMPTY,
    patientIdentifier: '',
  };


  static getDerivedStateFromProps({ newCaseId }) {
    // close if new case was sucecssfully created
    return newCaseId !== null ? { open: false } : null;
  }

  handleOpen = () => { this.setState({ open: true }); };

  handleClose = () => { this.setState({ open: false }); };

  handleOptionChange = ({ target: { value } }) => {
    this.setState({ optionSelected: value });
  }

  handlePatientIdentifierChange = ({ target: { value } }) => {
    this.setState({ patientIdentifier: value });
  }

  handleCreateCase = () => {
    const { optionSelected, patientIdentifier } = this.state;
    const {
      createCasePreFilledDataByPatientIdentifier,
      casePartSelect,
      createCase,
    } = this.props;

    if (optionSelected === this.options.CREATE_EMPTY) {
      createCase();
      casePartSelect(CASE_PART_ONE);
    } else {
      createCasePreFilledDataByPatientIdentifier(patientIdentifier);
    }
    this.setState({ patientIdentifier: '' });
  }

  handleButtonClick = () => {
    const {
      selectedCase,
      hasUnsavedChanges,
      showConfirmModal,
      user,
    } = this.props;

    const canRetrievePatientInfo = user.role === userRoles.surgeon || user.role === userRoles.admin;

    const functionToRender = () => {
      if (canRetrievePatientInfo) {
        this.handleOpen();
      } else {
        this.handleCreateCase();
      }
    };

    if (selectedCase.id && hasUnsavedChanges) {
      showConfirmModal(MODAL_CONFIRM_DISCARD_CHANGES, { onConfirm: functionToRender });
    } else {
      functionToRender();
    }
  };


  render() {
    const { newCaseId } = this.props;
    const { optionSelected, open, patientIdentifier } = this.state;

    const focusPatientIdentifierField = input => {
      if (input) setTimeout(() => { input.focus(); }, 100);
    };

    return (
      <>
        <CreateNewCaseButton disabled={newCaseId !== null} onClick={this.handleButtonClick} />
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          className="modal modal--new-case"
          onBackdropClick={this.handleClose}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle className="modal-new-case-options-title">
            New Case
          </DialogTitle>
          <DialogContent className="modal-content">

            <RadioGroup
              onChange={this.handleOptionChange}
              name="modal-new-case-options-radio-group"
              value={optionSelected}
            >
              <FormControlLabel
                control={<Radio />}
                value={this.options.CREATE_EMPTY}
                label="Create empty case"
              />
              <FormControlLabel
                control={<Radio />}
                value={this.options.RETRIEVE_INFO}
                label="Retrieve patient information from LIS"
              />
            </RadioGroup>

            <TextField
              name="patient-identifier"
              className="patient-identifier-field"
              disabled={optionSelected !== this.options.RETRIEVE_INFO}
              placeholder="Patient identifier"
              onChange={this.handlePatientIdentifierChange}
              value={patientIdentifier}
              ref={focusPatientIdentifierField}
            />

            <hr />
            <DialogActions className="modal-new-case-options-buttons">
              <Button variant="contained" onClick={this.handleClose}>cancel</Button>
              <Button
                variant="contained"
                disabled={optionSelected === this.options.RETRIEVE_INFO && !patientIdentifier.length}
                onClick={this.handleCreateCase}
              >
                Create case
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => (
  {
    selectedCase: state._case.selectedCase,
    hasUnsavedChanges: isDirty('caseClinicalInformation')(state)
      || isDirty('caseGeneralInformation')(state)
      || isDirty('caseSpecimenForm')(state)
      || state._case.tableHasChanged
      || state._case.pathologistsToAssign.length > 0
      || state._case.pathologistsToUnassign.length > 0,
    newCaseId: state._case.newCaseId,
    user: state.auth.user,
  }
);
export default connect(mapStateToProps, {
  createCase,
  casePartSelect,
  showConfirmModal,
  createCasePreFilledDataByPatientIdentifier,
})(CreateNewCase);
